export const sanitizeUrlSearchParams = (url, allowedKeys) => {
  if (!url || !allowedKeys) {
    return url;
  }

  const localUrl = new URL(url.toString());
  const allowed = new Set(allowedKeys);
  const clean = new URLSearchParams();

  for (const [key, value] of localUrl.searchParams) {
    if (allowed.has(key)) {
      clean.append(key, value);
    }
  }

  localUrl.search = clean.toString();

  return localUrl;
};
